
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as gonh5cpLj2NHWhF7eOak2qR1_I161lz_HAdaiknynansMeta } from "/codebuild/output/src2891380937/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexBkq89jvGkdkbOQqwW2Yl3MdnJGgBk4KGDBTIJ3tDcWUMeta } from "/codebuild/output/src2891380937/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchxjLdYZODIbra7BasySJS0EfWFloVxDHuFAOpKGyiwXIMeta } from "/codebuild/output/src2891380937/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexMxKjm3_45uX2gNttYPei0tZIXjKR4LGfmnYnT0aFPlfDcMeta } from "/codebuild/output/src2891380937/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93uUy6iUDJrJf1gAEwT4MktYp72XyJ6poMjKYyrlLZyOMMeta } from "/codebuild/output/src2891380937/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexWQLorI4Tvz42pFmga_45GSlOM6ereIP4DR9ptylgOb72gMeta } from "/codebuild/output/src2891380937/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93hKIoiLIKRfPWd83sCGglV1PgBu8BMVnJVfjIpxpFvrMMeta } from "/codebuild/output/src2891380937/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexFKVDFzY30XGYueGs88Pp5lTTRbz1cmZckhdjcYGfQ3AMeta } from "/codebuild/output/src2891380937/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93jG32q8TUzLoxIQXSS87Wbdxgo8MDyI5sJfRFdqrEw9QMeta } from "/codebuild/output/src2891380937/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexix091Q0zvVZF0dCxwTxBQCGmvbpg27zze5YU5PSesaoMeta } from "/codebuild/output/src2891380937/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexgoihNzKOP47CR8D6el_45yF_hJIXDTg4tVVPkqsKuA9iwMeta } from "/codebuild/output/src2891380937/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src2891380937/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src2891380937/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src2891380937/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src2891380937/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src2891380937/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexWQLorI4Tvz42pFmga_45GSlOM6ereIP4DR9ptylgOb72gMeta || {},
    component: () => import("/codebuild/output/src2891380937/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src2891380937/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexFKVDFzY30XGYueGs88Pp5lTTRbz1cmZckhdjcYGfQ3AMeta || {},
    component: () => import("/codebuild/output/src2891380937/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src2891380937/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexix091Q0zvVZF0dCxwTxBQCGmvbpg27zze5YU5PSesaoMeta || {},
    component: () => import("/codebuild/output/src2891380937/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexgoihNzKOP47CR8D6el_45yF_hJIXDTg4tVVPkqsKuA9iwMeta || {},
    component: () => import("/codebuild/output/src2891380937/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]